const SignatureRequiredInput = require('../signature_required_input');
const {
  store: ShippingLabelStore,
  actions: ShippingLabelActions,
} = require('../shipping_label_form_module');
const { mapStateToProps } = require('@reverbdotcom/discovery-ui');

function mapper() {
  const { insurancePolicy, shipment } = ShippingLabelStore.getState();
  let required = false;
  let defaultChecked = false;

  if (insurancePolicy && shipment) {
    if (!insurancePolicy.cannotInsure) {
      required = insurancePolicy.insuranceRequired || shipment.insured;
    }
    defaultChecked = shipment.signatureRequired;
  }

  return {
    required,
    defaultChecked,
    toggleSignatureRequired: ShippingLabelActions.toggleSignatureRequired,
  };
}

module.exports = mapStateToProps({
  mapper, stores: [ShippingLabelStore],
})(SignatureRequiredInput, 'SignatureRequiredInput');



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/containers/signature_required_input_container.jsx